export const resources = {
  es: {
    translation: {
      "contact-us": "Contáctanos",
      "privacy-policy": "Política de privacidad",
    },
  },
  fr: {
    translation: {
      "contact-us": "Contactez-nous",
      "privacy-policy": "Politique de confidentialité",
    },
  },
  en: {
    translation: {
      "contact-us": "Contact us",
      "privacy-policy": "Privacy policy",
    },
  },
};
